import type { ContextParams, EditorSDK } from '@wix/platform-editor-sdk';
import type { EditorScriptFlowAPI } from '@wix/yoshi-flow-editor';
import type { IFedopsLogger } from '../services/FedopsLogger/FedopsLogger';
import { container } from './container';
import { Services } from './services';

export function initDynamicServices(
  editorSDK: EditorSDK,
  appDefinitionId: string,
  options: ContextParams,
  flowApi: EditorScriptFlowAPI,
  fedopsLogger: IFedopsLogger,
) {
  container
    .bind(Services.PlatformWixExperiments)
    .toConstantValue(flowApi.experiments);

  container.bind(Services.EditorSDK).toConstantValue(editorSDK);
  container.bind(Services.FedopsLogger).toConstantValue(fedopsLogger);

  container
    .bind(Services.PlatformEssentials)
    .toConstantValue(flowApi.essentials);

  container
    .bind(Services.PlatformHttpClient)
    .toConstantValue(flowApi.httpClient);

  container
    .bind(Services.PlatformTranslations)
    .toConstantValue(flowApi.translations);

  if (!flowApi.panoramaClient) {
    throw new Error('No panorama client in flow api');
  }

  container
    .bind(Services.PlatformPanorama)
    .toConstantValue(flowApi.panoramaClient);

  const readyAppDataService = container.get(Services.ReadyAppData);
  readyAppDataService.initialize(appDefinitionId, options);
}
